// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/duration.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'duration',
	post: false,
	require: function(config, filter) { return sorted('duration', filter) > 0 },
	run: function(config, filter, data, query) {
		var reverse = sortReverse('duration', filter)
		var priority = sortPriority('duration', filter)
		if (reverse) {
			query.order('g.game_time_max', true, priority)
			query.order('g.game_time_min', true, priority + 0.01)
		} else {
			query.order('g.game_time_min', false, priority)
			query.order('g.game_time_max', false, priority + 0.01)
		}
	}
}
